import ky404 from './index.vue'

ky404.install = function (app) {
  app.component(ky404.name, ky404)
}

export default ky404



//////////////////
// WEBPACK FOOTER
// ./packages/404/index.js
// module id = null
// module chunks = 